module.exports = __webpack_public_path__ + "static/guy.dacc0ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/img/guy.png
// module id = 90
// module chunks = 144251824217401 183328146348521 186063380969677